/**
 * Created by vlad.p on 8/9/2017.
 */

import {Injectable} from "@angular/core";
import {BaseApi} from "./baseService";
import {ConfigService} from "./configService";
import {Http, RequestOptions} from "@angular/http";
import {BaseResponse} from "../objects/common/baseResponse";
import {Group} from "../objects/groups/group";

@Injectable()
export class GroupService extends BaseApi {

    constructor(http: Http, configService: ConfigService) {
        super(http, configService);
    }

    public getAllGroups(): Promise<BaseResponse<Group[]>> {

        return this.get(new RequestOptions({
            url: `groups`
        }));
    }

}


// WEBPACK FOOTER //
// ./app/services/groupService.ts